<template>
  <div class="translation">
    <header>
      <p class="header-title">{{$t('project.translation')}}</p>
      <div class="header-info">
        <div class="header-info-l">
          <el-tooltip effect="dark" :disabled="tipsDisabled"
                      :content="$i18n.locale === 'zh' ?$t('newProjectV2.langPair')+headerInfo.langDesc:$t('newProjectV2.langPair')+headerInfo.enlangDesc"
                      placement="top-start">
            <div class="info-item" @mouseover="mouseOverShowTips($event)">
              <span class="lable">{{$t('newProjectV2.langPair')}}：</span>
              <span>{{$i18n.locale === 'zh' ?headerInfo.langDesc:headerInfo.enlangDesc}}</span>
            </div>
          </el-tooltip>
          <i></i>
          <el-tooltip effect="dark" :disabled="tipsDisabled"
                      :content="$i18n.locale === 'zh'?$t('newProjectV2.domain')+headerInfo.transDomainName:$t('newProjectV2.domain')+headerInfo.domainCode"
                      placement="top-start">
            <div class="info-item" @mouseover="mouseOverShowTips($event)">
              <span class="lable">{{$t('newProjectV2.domain')}}：</span>
              <span>{{$i18n.locale === 'zh'?headerInfo.transDomainName:headerInfo.domainCode}}</span>
            </div>
          </el-tooltip>
          <i></i>
          <el-tooltip effect="dark" :disabled="tipsDisabled"
                      :content="$t('intelligentTranslation.Numberofdocuments')+':'+headerInfo.fileNum+''"
                      placement="top-start">
            <div class="info-item" @mouseover="mouseOverShowTips($event)">
              <span class="lable">{{$t('intelligentTranslation.Numberofdocuments')}}：</span>
              <span class="blur">{{headerInfo.fileNum}}</span>
            </div>
          </el-tooltip>
          <i></i>
          <el-tooltip effect="dark" :disabled="tipsDisabled"
                      :content="$t('intelligentTranslation.Totalwords')+':'+headerInfo.fileNumbertotal+''"
                      placement="top-start">
            <div class="info-item" @mouseover="mouseOverShowTips($event)">
              <span class="lable">{{$t('intelligentTranslation.Totalwords')}}：</span>
              <span class="blur">{{headerInfo.fileNumbertotal}}</span>
            </div>
          </el-tooltip>
          <i></i>
          <el-tooltip effect="dark" :disabled="tipsDisabled"
                      :content="$t('jobManagementV2.translationTime')+':'+headerInfo.translationTime+'s'"
                      placement="top-start">
            <div class="info-item" @mouseover="mouseOverShowTips($event)">
              <span class="lable">{{$t('jobManagementV2.translationTime')}}：</span>
              <span class="blur">{{formatemtConst(headerInfo.translationTime)}}</span>
            </div>
          </el-tooltip>
          <i></i>
        </div>
        <div class="header-info-r">
          <!-- 下载全部 -->
          <el-button size="small" type="primary" class="downloaAll" @click="handleDownloadAll">
            {{$t('memoryBankV2.Downloadall')}}
          </el-button>
        </div>
      </div>
    </header>
    <main>
      <el-table class="tabBox" border :data="tableData">
        <el-table-column type="index" :label="$t('projectV2.index')" width="60" align="center">
          <template slot-scope="{$index}">
            {{formateIndex($index)}}
          </template>
        </el-table-column>
        <el-table-column prop="name" :label="$t('jobManagementV2.fileName')" align="center"
                         :show-overflow-tooltip="true">
          <template slot-scope="{row}">
            <span class="filename" @click="handleDetail( row)">{{row.name}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="fileSize" :label="$t('jobManagementV2.fileSize')" align="center"
                         :show-overflow-tooltip="true">
          <template slot-scope="{row}">
            <p>{{formateSize(row.fileSize)}}</p>
          </template>
        </el-table-column>
        <el-table-column prop="sourceWordNum" :label="$t('project.wordNumber')" align="center"
                         :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column :label="$t('task.schedule')" align="center" :show-overflow-tooltip="true">
          <template slot-scope="{row}">
            <el-progress :stroke-width="8" :percentage="row.progress" v-if="row.status!==1">
            </el-progress>
            <el-progress :stroke-width="8" :percentage="100" v-else>
            </el-progress>
          </template>
        </el-table-column>
        <el-table-column prop="name" :label="$t('intelligentTranslation.Translationstatus')"
                         align="center" :show-overflow-tooltip="true" min-width="160">
          <template slot-scope="{row}">
            <span :class="`status_${row.status} status` ">{{formateStatus(row.status)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="mtConst" :label="$t('intelligentTranslation.Time')" align="center"
                         class-name="progress">
          <template slot-scope="{row}">
            <span>{{formatemtConst(row.mtConst)}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('common.operation')" min-width="80" align="center"
                         class-name="operation">
          <template slot-scope="{row}">
            <el-tooltip class="item" effect="dark" :content="$t('personCenterV2.check')"
                        placement="bottom">
              <i class="icon-detail" @click.stop="handleDetail( row)"></i>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" :content="$t('termBankV2.downLoad')"
                        placement="bottom" v-if="row.status===1">
              <i class="icon-download" @click.stop="handleDownload(row)"></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </main>
    <footer>
      <el-button size="small" class="translationHistory" @click="handlerTranslationHistory">
        {{$t('fileManage.transHistory')}}
      </el-button>
      <el-button size="small" type="primary" class="icon-upload" @click="handlerUpload">
        {{$t('intelligentTranslation.Continuetoupload')}}
      </el-button>
    </footer>
    <continueupload-dialog :fileList="tableData" :createObj="{ 'langDesc': queryData.langDesc }"
                           :uploadFileVisible="uploadFileVisible"
                           @uploadFileCancel="uploadFileCancel" @updateFileList="updateFileList">

    </continueupload-dialog>
    <translationDownload-dialog :downloadVisible="downloadVisible" :downloadType="downloadType"
                                @handlerClose="closeDownload" :downloadId="downloadId"
                                :idList="idList" @handlerdownLoading="handlerdownLoading">
    </translationDownload-dialog>
    <div v-show="isDownloadLoading" id="downloadLoadingBox">
      <div class="loadingMain">
        <i class="el-icon-loading"></i>
        <p>{{$t('projectDetailsV2.downloading')}}</p>
      </div>
    </div>
  </div>
</template>
<script>
import {
  queryFilePageByProjectID,
  checkTransStatus,
} from '@/services/projectDetailsApi';
import continueuploadDialog from "../../../components/continueuploadDialog";
import translationDownloadDialog from "../../../components/translationDownloadDialog"
export default {
  name: "translation",
  data() {
    return {
      headerInfo: {
        langDesc: "",
        enlangDesc: "",
        transDomainName: "",
        domainCode: "",
        fileNum: 0,
        fileNumbertotal: 0,
        translationTime: "-"
      },
      queryData: {},
      tableData: [{}],
      uploadFileVisible: false,
      tipsDisabled: true,
      params: {
        filter: {
          project_id: null,
        },
        page: 1,
        rows: 10,
        sort: {

        }
      },
      downloadVisible: false,
      downloadType: "",
      downloadId: null,
      idList: [],
      timeOut: null,
      isDownloadLoading: false
    }
  },
  components: { continueuploadDialog, translationDownloadDialog },
  mounted() {
    this.queryData = (JSON.parse(this.$Base64.decode(this.$route.query.key)))
    this.getDocumentTranslationPage();
    this.tableOut();
  },
  methods: {
    handlerdownLoading(type) {
      if (type === "open") {
        this.isDownloadLoading = true;
        this.downloadVisible = false
      } else {
        this.isDownloadLoading = false;
      }
    },
    mouseOverShowTips(e) {
      const el = e.target
      e.preventDefault();
      if (el.nodeName === 'DIV') {
        if (el.scrollWidth > el.clientWidth) {
          this.tipsDisabled = false;
        } else {
          this.tipsDisabled = false;
        }
        this.tipsDisabled = el.scrollWidth > el.clientWidth ? false : true
      }
    },
    formateStatus(status) {
      switch (parseInt(status)) {
        case 0:
          return this.$t('projectDetailsV2.fileParsingFailure');
        case 2:
          return this.$t('projectDetailsV2.notBegin');
        case 3:
          return this.$t('projectDetailsV2.notBegin');
        case 1:
          return this.$t('intelligentTranslation.Translationcompleted'); //翻译完成
        case 4:
          return this.$t('projectDetailsV2.translating');
        default: 0
          return this.$t('projectDetailsV2.translating');
      }
    },
    formatemtConst(mtConst) {
      return (mtConst / 1000) + "s"
    },
    handleDetail(row) {
      if (row.status === 0) {
        this.$message.closeAll();
        this.$message({
          message: row.remark || this.$t('projectDetailsV2.fileParsingFailure'),
          type: "warning",
        });
        return;
      }
      if (row.status > 1) {
        this.$message.closeAll();
        this.$message({
          message: this.$t('projectDetailsV2.fileParsingNotView'),
          type: "warning",
        });
        return;
      }
      let userId = JSON.parse(localStorage.getItem("userInfo")).id;
      let obj = {};
      Reflect.set(obj, 'project', (row.finish));
      Reflect.set(obj, 'sourceLang', (row.sourceLang));
      Reflect.set(obj, 'targetLang', (row.targetLang));
      Reflect.set(obj, 'taskName', (row.name));
      Reflect.set(obj, 'userId', (userId || ''));
      Reflect.set(obj, 'wordNum', (row.sourceWordNum));
      Reflect.set(obj, 'transStatus', 2);
      Reflect.set(obj, 'isSplit', row.isSplit);
      Reflect.set(obj, 'langDesc', row.langDesc);
      Reflect.set(obj, 'taskType', 1);
      Reflect.set(obj, 'progress', row.progress);
      Reflect.set(obj, 'fileSuffix', row.fileUsableSuffix);
      Reflect.set(obj, 'transModel', row.transModel);
      Reflect.set(obj, 'taskCount', row.taskCount);
      Reflect.set(obj, 'finish', row.finish);
      sessionStorage.setItem("fileName", row.name)
      //老版参数
      Reflect.set(obj, 'fileId', (row.id));
      Reflect.set(obj, 'type', 'project');
      Reflect.set(obj, 'routerType', "translation")
      Reflect.set(obj, 'routerData', this.queryData)
      Reflect.set(obj, 'taskId', null);
      Reflect.set(obj, 'projectId', (row.projectId));
      let routeData = this.$router.resolve({
        path: "/translationDetail",
        query: {
          key: this.$Base64.encode(
            JSON.stringify(obj)
          )
        }
      });
      window.open(routeData.href, "_self");
    },
    handleDownload(row) {
      this.downloadId = row.id;
      this.downloadVisible = true;
    },
    handleDownloadAll() {
      if(this.tableData.every(item => item.status === 1)){
        this.idList = this.tableData.map(item => item.id);
        this.downloadVisible = true;
        this.downloadType = "batchdownload"
      }else{
        this.$message.warning('有文件未翻译完成或解析失败，请稍后重试')
        return
      }
    },
    handlerUpload() {
      if (this.tableData.length === 10) {
        this.$message.closeAll();
        this.$message.warning(this.$t('intelligentTranslation.Uptotenfiles'))
        return
      }
      this.uploadFileVisible = true;
    },
    uploadFileCancel() {
      this.uploadFileVisible = false;
    },
    closeDownload() {
      this.downloadVisible = false;
    },
    updateFileList() {
      this.getDocumentTranslationPage();
      this.tableOut();
    },
    async getDocumentTranslationPage() {
      Reflect.set(this.params.filter, "project_id", this.queryData.project_id)
      const { list, success } = await queryFilePageByProjectID(this.params);
      if (success) {
        this.tableData = list;
        let langArr = this.queryData.langDesc.split('>')
        this.headerInfo.langDesc = langArr[0] + "-" + langArr[1]
        this.headerInfo.transDomainName = this.queryData.transDomainName;
        this.headerInfo.domainCode = this.$domainCase[this.queryData.domainCode]
        this.headerInfo.fileNum = this.tableData.length;
        this.headerInfo.enlangDesc = this.$langCase[this.queryData.sourceLang] + ' > ' + this.$langCase[this.queryData.targetLang]
        this.headerInfo.fileNumbertotal = this.tableData.reduce((pre, cur) => {
          return pre + cur.sourceWordNum
        }, 0)
        this.headerInfo.translationTime = this.tableData.reduce((pre, cur) => {
          return (pre + cur.mtConst)
        }, 0)
      }
    },
    tableOut() {
      let self = this;
      if (self.timeOut !== null) { return; }
      self.timeOut = window.setInterval(async () => {
        let list = self.tableData || [];
        let params = {
          transFileIdList: [],
          transProjectIdList: [],
        };
        list.forEach((item) => {
          if (item.status > 1) {
            params.transFileIdList.push(item.id);
          }
        });
        if (
          params.transFileIdList.length < 1 &&
          params.transProjectIdList.length < 1
        ) {
          await this.getDocumentTranslationPage();
          self.clear();
        } else {
          let { result, success } = await checkTransStatus(params);
          if (!success) {
            return;
          }
          if (result.transFileRespVoList != null) {
            result.transFileRespVoList.forEach((i) => {
              list.forEach((item) => {
                if (item.id === i.id) {
                  item.status = i.status;
                  item.finish = i.finish || 0;
                  item.fileSize = i.fileSize;
                  item.sourceWordNum = i.sourceWordNum;
                  item.fileUsableSuffix = i.fileUsableSuffix;
                  item.mtConst = i.mtConst
                }
              });
            });
          }
        }
      }, 3000);
    },
    clear() {
      this.isTime = "";
      clearInterval(this.timeOut);
      this.timeOut = null;
    },
    formateIndex(index) {
      if (index >= 9) {
        return index + 1;
      } else {
        return "0" + (index + 1)
      }
    },
    formateSize(size) {
      let kbsize = (size / 1024).toFixed(2)
      if (kbsize > 1024) {
        return size = (kbsize / 1024).toFixed(2) + "M"
      } else {
        return size = kbsize + "kb"
      }
    },
    handlerTranslationHistory() {
      this.$router.push({ name: "translationHistory" })
    },
  }
}
</script>
<style lang="less" scoped>
@import "./assets/style.less";
</style>